export const LAST_AUTH_ROUTE_KEY = "last-auth-route";

export const setLastAuthRoute = (route: string): void => {
  localStorage.setItem(LAST_AUTH_ROUTE_KEY, route);
};

export const getLastAuthRoute = (): string | null => {
  return localStorage.getItem(LAST_AUTH_ROUTE_KEY);
};
